import { JSONObject } from '../../../../../../types/types';
import { resolveStringPlaceholders } from '../../../../../../utils/json/resolveStringPlaceholders';

export async function resolveFormat(
  formatExpression: string,
  ctx: JSONObject
): Promise<string> {
  const result = await resolveStringPlaceholders(formatExpression, ctx);
  if (result == null) return formatExpression;
  // pure-placeholder JSONata may return non-string — coerce via String()
  return typeof result === 'string' ? result : String(result);
}
